// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type ServicesAndProductsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ServicesAndProductsQuery = {
  __typename?: "query_root";
  medspaServiceMenuItem: Array<{
    __typename?: "MedspaServiceMenuItem";
    id: string;
    oldCategoryId?: string | null;
    name: string;
    description: string;
    price: string;
    isOnlineBookingEnabled: boolean;
  }>;
  serviceCategory: Array<{
    __typename?: "serviceCategory";
    id: string;
    name: string;
  }>;
  product: Array<{
    __typename?: "product";
    id: string;
    name: string;
    productType: string;
    price: string;
    unit?: string | null;
    serviceMenuItemProducts: Array<{
      __typename?: "MedspaServiceMenuItemOldProducts";
      id: string;
      serviceMenuItem: {
        __typename?: "MedspaServiceMenuItem";
        name: string;
        id: string;
      };
    }>;
  }>;
  medspaServiceProduct: Array<{
    __typename?: "MedspaServiceProduct";
    id: string;
    price: string;
    serviceProduct: {
      __typename?: "ServiceProduct";
      id: string;
      name: string;
      unitOfMeasurement: string;
    };
  }>;
};

export const ServicesAndProductsDocument = gql`
  query ServicesAndProducts {
    medspaServiceMenuItem(where: { deletedAt: { _isNull: true } }) {
      id
      oldCategoryId
      name
      description
      price
      isOnlineBookingEnabled
    }
    serviceCategory {
      id
      name
    }
    product(where: { deleted: { _eq: false } }) {
      id
      name
      productType
      serviceMenuItemProducts {
        id
        serviceMenuItem {
          name
          id
        }
      }
      price
      unit
    }
    medspaServiceProduct(where: { isEnabled: { _eq: true } }) {
      id
      price
      serviceProduct {
        id
        name
        unitOfMeasurement
      }
    }
  }
`;

/**
 * __useServicesAndProductsQuery__
 *
 * To run a query within a React component, call `useServicesAndProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicesAndProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicesAndProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useServicesAndProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ServicesAndProductsQuery,
    ServicesAndProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ServicesAndProductsQuery,
    ServicesAndProductsQueryVariables
  >(ServicesAndProductsDocument, options);
}
export function useServicesAndProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ServicesAndProductsQuery,
    ServicesAndProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ServicesAndProductsQuery,
    ServicesAndProductsQueryVariables
  >(ServicesAndProductsDocument, options);
}
export function useServicesAndProductsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ServicesAndProductsQuery,
        ServicesAndProductsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ServicesAndProductsQuery,
    ServicesAndProductsQueryVariables
  >(ServicesAndProductsDocument, options);
}
export type ServicesAndProductsQueryHookResult = ReturnType<
  typeof useServicesAndProductsQuery
>;
export type ServicesAndProductsLazyQueryHookResult = ReturnType<
  typeof useServicesAndProductsLazyQuery
>;
export type ServicesAndProductsSuspenseQueryHookResult = ReturnType<
  typeof useServicesAndProductsSuspenseQuery
>;
export type ServicesAndProductsQueryResult = Apollo.QueryResult<
  ServicesAndProductsQuery,
  ServicesAndProductsQueryVariables
>;
